import { __awaiter, __generator } from "tslib";
import { Command } from './client-msg.interface';
import { ClientProxy } from './client-proxy';
import { NativeEngineCursor } from './cursor';
import { assertResp } from './utils/common';
import { KeyUtils } from './utils/key-utils';
import { QueryConditionBuilder } from './utils/query-condition-builder';
var NativeEngineIndex = /** @class */ (function () {
    function NativeEngineIndex(dbName, table, indexSchema, mode, engineAspects) {
        var _this = this;
        var _a;
        this.dbName = dbName;
        this.table = table;
        this.mode = mode;
        this.engineAspects = engineAspects;
        this.name = indexSchema.name;
        this.keyPath = indexSchema.path;
        this.unique = (_a = indexSchema.unique) !== null && _a !== void 0 ? _a : false;
        this.transaction = table.transaction;
        this.reqErrorObserver = function (error) { var _a; return (_a = _this.transaction) === null || _a === void 0 ? void 0 : _a.notifyTransactionFail(error); };
        if (engineAspects === null || engineAspects === void 0 ? void 0 : engineAspects.index) {
            this.applyAspectPatch();
        }
    }
    NativeEngineIndex.prototype.getAll = function (query, count) {
        return __awaiter(this, void 0, void 0, function () {
            var req, resp;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            command: Command.GET_ALL,
                            dbName: this.dbName,
                            tableName: this.table.tableName,
                            where: query
                                ? new QueryConditionBuilder()
                                    .addKeyQueryCondition(this.keyPath, query)
                                    .setLimit(count !== null && count !== void 0 ? count : Number.MAX_VALUE)
                                    .build()
                                : undefined,
                        };
                        return [4 /*yield*/, this.sendRequest(req)];
                    case 1:
                        resp = _a.sent();
                        assertResp(resp, 'getAll', this.reqErrorObserver);
                        if (!resp.result) {
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/, resp.result.map(function (value) { return KeyUtils.deleteUnionKeyIfNeed(value, _this.table.keyPath); })];
                }
            });
        });
    };
    NativeEngineIndex.prototype.getAllKeys = function (query, count) {
        return __awaiter(this, void 0, void 0, function () {
            var values, keys;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAll(query !== null && query !== void 0 ? query : undefined, count)];
                    case 1:
                        values = _a.sent();
                        if (!values) {
                            return [2 /*return*/, []];
                        }
                        keys = values.map(function (value) { return KeyUtils.getKeyFromValue(value, _this.table.keyPath); });
                        return [2 /*return*/, keys];
                }
            });
        });
    };
    NativeEngineIndex.prototype.get = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var req, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            command: Command.GET,
                            dbName: this.dbName,
                            tableName: this.table.tableName,
                            where: new QueryConditionBuilder().addKeyQueryCondition(this.keyPath, query).build(),
                        };
                        return [4 /*yield*/, this.sendRequest(req)];
                    case 1:
                        resp = _a.sent();
                        assertResp(resp, 'get', this.reqErrorObserver);
                        if (resp.result) {
                            return [2 /*return*/, KeyUtils.deleteUnionKeyIfNeed(resp.result, this.table.keyPath)];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    NativeEngineIndex.prototype.openCursor = function (query, direction) {
        return __awaiter(this, void 0, void 0, function () {
            var values;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAll(query)];
                    case 1:
                        values = _a.sent();
                        if (!values) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, new NativeEngineCursor(values, this.table, direction !== null && direction !== void 0 ? direction : 'next', this.mode)];
                }
            });
        });
    };
    NativeEngineIndex.prototype.sendRequest = function (req) {
        var _a, _b;
        if ((_a = this.transaction) === null || _a === void 0 ? void 0 : _a.transactionID) {
            req.transaction = this.transaction.transactionID;
        }
        var respPromise = ClientProxy.send(req);
        (_b = this.transaction) === null || _b === void 0 ? void 0 : _b.addResponsePromise(respPromise);
        return respPromise;
    };
    /**
     * bind the hook stub to the index object
     */
    NativeEngineIndex.prototype.applyAspectPatch = function () {
        var _a;
        var indexAspects = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.index;
        var hookTarget = this;
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.get.patch(hookTarget, 'get');
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.getAll.patch(hookTarget, 'getAll');
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.getAllKeys.patch(hookTarget, 'getAllKeys');
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.openCursor.patch(hookTarget, 'openCursor');
    };
    return NativeEngineIndex;
}());
export { NativeEngineIndex };
//# sourceMappingURL=database-index.js.map